import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "../../data/site";

function Counter({ value, decimals = 0, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(start + (value - start) * eased);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n.toFixed(decimals)}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section
      className="py-20 md:py-28 bg-white border-b border-zinc-200"
      data-testid="stats-section"
    >
      <div className="container">
        <div className="max-w-3xl mb-14">
          <p className="text-overline text-electric mb-3">05 — Numbers</p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-charcoal text-balance">
            App Growth Results That Speak for Themselves
          </h2>
        </div>

        <dl className="grid grid-cols-2 md:grid-cols-5 divide-x divide-zinc-200 border-y border-zinc-200">
          {STATS.map((s, idx) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.05 }}
              className="px-5 py-10 first:pl-0"
              data-testid={`stat-${idx}`}
            >
              <dt className="text-overline text-zinc-500 mb-3">{s.label}</dt>
              <dd className="font-display text-5xl md:text-6xl font-black text-charcoal tracking-tight leading-none">
                <Counter
                  value={s.value}
                  decimals={s.decimals || 0}
                  suffix={s.suffix}
                />
              </dd>
            </motion.div>
          ))}
        </dl>
      </div>
    </section>
  );
}
